var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeBohotSides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_26714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.053 111.921L174.871 111.218L130.623 98.6006L175.053 111.921Z",
    fill: "#FFA9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.992 174.586L130.625 98.6005L56.2375 118.864L110.992 174.586Z",
    fill: "#ADEC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2342 118.865L40.1016 135.471L56.2385 118.864L56.2342 118.865Z",
    fill: "#FFA9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2413 118.864L40.1029 135.471L24.7072 151.317L24.3672 151.666L76.9245 165.754L110.855 175.133L110.924 174.865L110.996 174.587L56.2413 118.864Z",
    fill: "#94D246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73951 65.3299L1.04333 64.6462L17.5978 126.428L24.0077 151.125L24.2315 151.186L24.6998 151.315L40.0973 135.47L56.23 118.865L1.73951 65.3299Z",
    fill: "#81C62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4 24.7183L152.413 24.7224L151.917 24.808L151.598 24.8631L130.625 98.6014L174.871 111.22L175.088 111.281L168.7 87.4435L152.419 24.7147L152.4 24.7183Z",
    fill: "#D0FF95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97656 63.7109L34.3363 52.2936L68.5609 40.2238L74.1937 38.1863L74.4879 38.1334L74.6931 38.0616L64.7468 0.941228L1.97656 63.7109Z",
    fill: "#81C62A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2854 39.9704L68.5642 40.2247L34.3396 52.2945L1.97984 63.7118L1.45742 64.235L1.51859 64.469L33.9156 52.7577L1.52012 64.4747L1.74306 65.3295L56.2325 118.866L74.1847 38.2439L69.2854 39.9704Z",
    fill: "#ADEC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7456 0.940905L74.692 38.0613L74.7311 38.0477L75.2405 37.9601L80.0776 37.1297L115.287 30.8084L151.753 24.2543L64.7456 0.940905Z",
    fill: "#61AD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.754 24.2557L115.288 30.8098L80.8332 37.0007L74.7039 38.1026L74.4464 38.1502L74.2298 38.225L130.622 98.6016L151.596 24.8629L151.769 24.2594L151.754 24.2557Z",
    fill: "#ADEC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.993 174.586L111.197 174.793L175.056 111.921L130.626 98.6009L110.993 174.586Z",
    fill: "#94D246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2339 38.2246L130.628 98.6009L56.2401 118.863L56.2383 118.862L56.2344 118.864L74.1852 38.2422L74.2339 38.2246Z",
    fill: "#D0FF95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_26714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeBohotSides);
export default __webpack_public_path__ + "static/media/Type=Bohot_Sides.33835662b48186831f5450766bf6cbb0.svg";
export { ForwardRef as ReactComponent };